import type { ReactNode } from 'react';
import { useMatch } from 'react-router-dom';

export interface MainContentProps {
  children: ReactNode;
}

/**
 * Slot principal — usa <section> porque o Shell já tem <main> como wrapper
 * externo (a11y exige 1 main por documento).
 *
 * [container-type:inline-size] (E24.F1.T02): a section é um container-query
 * container para que headers full-bleed (.laudo-page__header) derivem o bleed
 * horizontal da largura REAL do content-box via 100cqw, em vez de constantes
 * vw hardcoded (frágeis a zoom/rem/scrollbar).
 *
 * E203.F1.T05 (mesa enxuta): a mesa do perito usa a largura toda da tela, para o documento do exame
 * e o original ao lado caberem lado a lado; as demais telas seguem com a largura de leitura.
 *
 * E216.F6.T01 (GUS-317, QA de 03/11): quem rola é a janela, não a section. Com `overflow-y-auto`, a
 * section vira caixa de rolagem que nunca rola, e o `sticky` de dentro se prende a ela: na mesa o
 * índice e "Anterior"/"Próxima" subiam com o exame. Na mesa, `overflow-x-clip` corta o que vaza na
 * horizontal sem virar caixa de rolagem, e o `sticky` se prende à janela.
 */
export function MainContent({ children }: MainContentProps) {
  const naMesa = useMatch('/casos/:id/mesa') !== null;
  return (
    <section
      id="main-content"
      tabIndex={-1}
      className={`flex-1 ${naMesa ? 'overflow-x-clip' : 'overflow-y-auto'} bg-bg px-8 py-7 [container-type:inline-size] focus:outline-none`}
    >
      <div className={`mx-auto w-full ${naMesa ? 'max-w-none' : 'max-w-shell-xl'}`}>{children}</div>
    </section>
  );
}
